import dayjsFn from 'dayjs'
import dayUTCPlugin from 'dayjs/plugin/utc'
import dayWeekOfYearPlugin from 'dayjs/plugin/weekOfYear'

dayjsFn.extend(dayUTCPlugin)
dayjsFn.extend(dayWeekOfYearPlugin)

export const dayjs = dayjsFn

export const isProd = process.env.NODE_ENV === 'production'
export const isDev = process.env.NODE_ENV === 'development'
export const isTest = process.env.NODE_ENV === 'test'

export function formatDate (date, format = 'YYYY-MM-DD', InvalidHolder = '') {
  const day = dayjs(date)
  if (!day.isValid()) return InvalidHolder

  return day.format(format)
}

export function isWeixin () { // 判断是否是微信
  const ua = navigator.userAgent.toLowerCase()
  return (ua.match(/MicroMessenger/i) + '') === 'micromessenger'
}

export function isEmptyObject (obj) {
  if (obj != null) {
    return Object.keys(obj).length === 0
  }

  return true
}

export function getTextContentFromHtml (html) {
  if (!html) return

  const el = document.createElement('div')
  el.innerHTML = html

  return el.textContent.trim()
}

/**
 * @param content
 * @param extra
 * @param isAppend
 */
export function debugText (content, extra, isAppend = false) {
  if (isProd) {
    return
  }

  const el = document.querySelector('#app')
  const ctx = document.createElement('div')

  ctx.innerHTML = `
    <h1 style="color: red; padding: 20px;">${content}</h1>
    <div style="font-size: 13px; padding: 20px 10px;word-break: break-all;">${extra}</div>
  `

  if (isAppend) {
    el.append(ctx)
  } else {
    el.innerHTML = ''
    el.append(ctx)
  }
}

/**
 * @param timeout
 * @return {Promise<void>}
 */
export async function delay (timeout = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout)
  })
}

export function isIOS () {
  try {
    if (navigator == null) return false
    const u = navigator.userAgent
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  } catch (e) {
    return false
  }
}

export function isiPhoneX () {
  if (!isIOS()) {
    return false
  }
  return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
}

/**
 * @param baseInfo
 */
export function setupWXShare (baseInfo) {
  if (!baseInfo) return

  const { cpCode } = baseInfo

  // TODO: tmp
  const isWuhanCp = parseInt(cpCode) === 3

  // share
  const dd = new FormData()
  const url = window.location.href
  dd.append('url', url)

  fetch(`https://${isProd ? '' : 't-'}consumer.doctopia.com.cn/Mobile/Wxbaseinterface/JsSdk`, {
    method: 'post',
    body: dd
  }).then(function (response) {
    return response.json()
  }).then(function (payload) {
    const configs = payload.data.signPackage
    wx.config(configs)

    const title = baseInfo.wShareTitle || document.title
    const desc = baseInfo.wShareDesc || '快来壹零医测一测吧 :)'

    const imgUrl = baseInfo.imgUrl || 'https://101wenda.doctopia.com.cn/wuhan101/hzdw_logo0.jpg'

    const sp = {
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: shareURL(), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      type: 'link', // 分享类型,music、video或link，不填默认为link
      dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
    }
    console.log(sp, baseInfo)

    if (isWuhanCp) {
      Object.assign(sp, {
        title: ' “新冠病毒感染”风险自我测评全新研发上线！',
        desc: '咳嗽两声，打个喷嚏，怀疑感染了新冠病毒？想去医院又怕感染？快来测一测就知道！'
      })
    }

    console.debug('[share sp]', sp)

    wx.ready(function () {
      wx.onMenuShareAppMessage(sp)
    })
    // app分享
    appShare(sp)
  }).catch(function (e) {
    console.error('[wx sdk error]', e)
  })

  // END

  function shareURL () {
    let result = url.replace('survey/chat', 'survey/entry')
    if (baseInfo.accountId) {
      const urlSearch = new URLSearchParams(result)
      urlSearch.set('refId', baseInfo.accountId)
      urlSearch.set('identity', baseInfo.identity)
      result = decodeURIComponent(urlSearch.toString())
    }
    return result
  }
}

// app分享
export function appShare (shareInfo) {
  // 是否处于app中
  const isApp = window.location.href.includes('one-sandbox')
  if (!isApp) {
    return
  }
  const bridge = window.__oneLiteBridge.bridge
  bridge.dispatchMsg({
    type: 'open-app-share',
    payload: {
      type: 'wechat',
      showType: 'navigator',
      mediaType: 'link',
      shareCode: '',
      title: shareInfo.title,
      url: shareInfo.link,
      thumb: shareInfo.imgUrl,
      description: shareInfo.desc
    }
  })
}

export function getAccountID () {
  return window.__oneAppConfig__ && window.__oneAppConfig__.accountInfo.account_id
}

/**
 * shence feature
 */
export function setupShence () {
  if (!isProd) {
    console.warn('[shence] skip initialization for non-production .')
    return
  }

  const assets = ['sensorsdata.min.js', 'heatmap.min.js', 'shence.js']

  Promise.all(assets.map(label => {
    console.debug('[loadScript]', label)
    return loadScript(`https://101wenda.doctopia.com.cn/${label}`)
  })).then(() => {
    const accountId = getAccountID()
    console.debug('[shence] accountID #', accountId)
    if (!accountId) return

    const { webPageview, pageClose, loginWithAccountId } = init(window.sensors)
    const isInterest = location.href.includes('interest')
    const typeName = isInterest ? '趣味' : '标准'
    const titleName = `[${typeName}测评] - ${document.title}`

    loginWithAccountId(accountId)
    webPageview(titleName)
    // pageLoadtime(titleName)
    window.addEventListener('unload', () => {
      pageClose(titleName)
    })
  })

  /**
   * @param sensors
   * @returns {}
   */
  function init (sensors) {
    const startTime = new Date() // 全局开始时间
    let end_time = '' // 用于计算页面加载的时间

    // 神策pageClose页面关闭事件
    function pageClose (title) {
      const endTime = new Date()
      const duration = (endTime.getTime() - startTime.getTime()) / 1000
      sensors.track('pageclose', {
        pageStayTime: duration,
        pageUrl: window.location.href,
        pageName: title
      })
    }

    // 神策pageLoadTime页面加载事件
    function pageLoadtime (title) {
      end_time = new Date()
      sensors.track('pageLoadTime', {
        loadTime: end_time.getTime() - startTime.getTime(),
        pageName: title
      })
    }

    // 神策web浏览事件
    function webPageview (title) {
      sensors.quick('autoTrackSinglePage', {
        pageName: title
      })
    }

    // 赋值openid
    function loginWithAccountId (accountId) {
      sensors.login(accountId)
    }

    return {
      pageClose,
      pageLoadtime,
      webPageview,
      loginWithAccountId
    }
  }
}

/**
 * @param src
 * @returns {Promise<unknown>}
 */
function loadScript (src) {
  return new Promise(function (resolve, reject) {
    const s = document.createElement('script')
    let r = false
    s.type = 'text/javascript'
    s.src = src
    s.async = true
    s.onerror = function (err) {
      reject(err, s)
    }
    s.onload = s.onreadystatechange = function () {
      // console.log(this.readyState); // uncomment this line to see which ready states are called.
      if (!r && (!this.readyState || this.readyState == 'complete')) {
        r = true
        resolve()
      }
    }
    const t = document.getElementsByTagName('script')[0]
    t.parentElement.insertBefore(s, t)
  })
}

let xibao = null

export function isVendorXiBao () {
  if (xibao != null) return xibao

  const flag = window.location.href
  const tag = 'xibao'

  const isXiBao = flag && !!~flag.indexOf(`from=${tag}`)

  if (isXiBao) {
    // parse query
    let query = flag.substr(flag.lastIndexOf('?') + 1)
    query = new URLSearchParams(query)

    xibao = Array.from(query.entries())
      .reduce(function (out, [k, v]) {
        out[k] = v
        return out
      }, {
        _url: query
      })
  } else {
    xibao = isXiBao
  }

  return xibao
}
